<template>
  <v-row justify="end">
    <v-col cols="3" class="py-0">
      <v-autocomplete
        v-model="branchOfficeId"
        prepend-icon="mdi-home-search"
        label="Seleccione una Sucursal"
        :items="BranchOffices"
        item-text="name"
        item-value="id"
        @change="Load()"
      ></v-autocomplete>
    </v-col>
    <v-col cols="2" class="py-0">
      <v-menu
        v-model="menuDateInit"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="dateInit"
            readonly
            label="Fecha Inicio"
            color="indigo darken-4"
            append-icon="mdi-calendar-multiselect"
            v-on="on"
          >
          </v-text-field>
        </template>
        <v-date-picker
          v-model="dateInit"
          locale="es-MX"
          @input="menuDateInit = false"
          @change="Load()"
        >
        </v-date-picker>
      </v-menu>
    </v-col>
    <v-col cols="2" class="py-0">
      <v-menu
        v-model="menuDateEnd"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="dateEnd"
            readonly
            label="Fecha Inicio"
            color="indigo darken-4"
            append-icon="mdi-calendar-multiselect"
            v-on="on"
          >
          </v-text-field>
        </template>
        <v-date-picker
          v-model="dateEnd"
          :min="dateInit"
          locale="es-MX"
          @input="menuDateEnd = false"
          @change="Load()"
        >
        </v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment';
export default {
  data(){
    return{
      //branchOffice
      branchOfficeId: null,
      //Dates
      dateInit: moment().format("YYYY-MM-DD"),
      dateEnd: moment().format("YYYY-MM-DD"),
      //Menus
      menuDateEnd: false,
      menuDateInit: false,
    }
  },
  methods:{
    Load(){
      const body = {
        branchOfficeId: this.branchOfficeId,
        startDate: this.dateInit,
        finishDate: this.dateEnd
      };
      this.$emit('sendFilters', body);
    }
  },
  computed: {
    BranchOffices(){
      return this.$store.state.BranchOffice;
    }
  }
}
</script>